import type { EventPayload } from '@side/analytics';

export enum TrackNotificationsEvent {
  ClickAuthorizeNotifications,
  AuthorizeNotificationsDismissed,
}

type EventTypeLabels = Record<TrackNotificationsEvent, string>;

export const NotificationsEventLabels: EventTypeLabels = {
  [TrackNotificationsEvent.ClickAuthorizeNotifications]: 'NOTIFICATIONS',
  [TrackNotificationsEvent.AuthorizeNotificationsDismissed]: 'NOTIFICATIONS',
};

type EventTypePayloads = Record<TrackNotificationsEvent, EventPayload>;

export const NotificationsEventsMap: EventTypePayloads = {
  [TrackNotificationsEvent.ClickAuthorizeNotifications]: {
    eventContainer: 'notifications_allow_modal',
    eventTarget: 'allow_notifications_button',
    eventType: 'click',
    task: 'allow_notifications',
  },
  [TrackNotificationsEvent.AuthorizeNotificationsDismissed]: {
    eventContainer: 'notifications_allow_modal',
    eventTarget: 'notifications_allow_modal',
    eventType: 'click',
    task: 'exit',
  },
};
